import React, {useEffect, useState} from 'react';
import {FaTimes} from "react-icons/fa";
import {useEdgeBuilder} from "../../association-network-context.jsx";
import InputSwitch from "../../../../../../components/input/input-switch.jsx";

export const initialToggle = {
    compact: {
        compact: false
    },
    individual: {
        age: true,
        mother: true,
        address: false,
    },
    vehicle: {
        brandModel: true,
        color: true,
        year: false,
    },
    encounter: {
        individuals: true,
        vehicles: true,
    },
    occurrence: {
        reason: true,
        address: true,
        status: false,
        description: false,
    },
    sos: {
        status: true,
        address: true,
    },
    bo: {
        address: true,
        reason: true,
        flagrant: false,
    },
}

const Config = ({showConfig, setShowConfig}) => {
    const {toggleItemsNode, setToggleItemsNode} = useEdgeBuilder();
    const [wasChanged, setWasChanged] = useState(false)

    useEffect(() => {
        if (wasChanged) {
            localStorage.setItem("config_association", JSON.stringify(toggleItemsNode));
        }
    }, [toggleItemsNode, wasChanged]);

    const handleCheckBox = (checked, id, target) => {
        setToggleItemsNode((prevState) => ({
            ...prevState,
            [target]: {
                ...prevState[target],
                [id]: checked
            },
        }));

        setWasChanged(true)
    }

    return (
        <>
            {
                showConfig &&
                <div onClick={() => setShowConfig(null)}
                     className="absolute w-screen h-screen right-0 top-[-15px] bg-[#7b7b7b24]"></div>
            }
            <div
                className={`fixed top-[53px] right-0  shadow-lg z-50 ${showConfig ? "translate-x-0" : "translate-x-full"}  transform transition-transform duration-300 ease-in-out bg-white h-[100vh] p-3 w-[300px]`}>
                <div className="mb-3 text-[#333]">
                    <div onClick={() => setShowConfig(null)}
                         className={"absolute top-0 left-0 p-[10px] cursor-pointer"}>
                        <FaTimes color={"#a3a3a3"}/>
                    </div>
                </div>
                <div>
                    <h3 className={"mt-3 mb-2 text-[18px]"}>Configurações de visualização</h3>
                    <div className={"mb-2"}>
                        <p className={"text-[16px] font-bold mb-1"}>Geral</p>
                        <div>
                            <InputSwitch
                                id="compact"
                                label="Visualização compacta"
                                checked={toggleItemsNode.compact.compact}
                                onChange={(checked) => handleCheckBox(checked, "compact", "compact")}
                            />
                        </div>
                    </div>
                    <div className={"mb-2"}>
                        <p className={"text-[16px] font-bold mb-1"}>Indivíduo</p>
                        <div className={"mb-1"}>
                            <InputSwitch
                                id="age"
                                label="Idade"
                                checked={toggleItemsNode.individual.age}
                                onChange={(checked) => handleCheckBox(checked, "age", "individual")}
                            />
                        </div>
                        <div className={"mb-1"}>
                            <InputSwitch
                                id="mother"
                                label="Nome da mãe"
                                checked={toggleItemsNode.individual.mother}
                                onChange={(checked) => handleCheckBox(checked, "mother", "individual")}
                            />
                        </div>
                        <div>
                            <InputSwitch
                                id="address"
                                label="Endereço"
                                checked={toggleItemsNode.individual.address}
                                onChange={(checked) => handleCheckBox(checked, "address", "individual")}
                            />
                        </div>
                    </div>
                    <div className={"mb-2"}>
                        <p className={"text-[16px] font-bold mb-1"}>Veículo</p>
                        <div className={"mb-1"}>
                            <InputSwitch
                                id={"brandModel"}
                                label="Marca/Modelo"
                                checked={toggleItemsNode.vehicle.brandModel}
                                onChange={(checked) => handleCheckBox(checked, "brandModel", "vehicle")}
                            />
                        </div>
                        <div className={"mb-1"}>
                            <InputSwitch
                                id={"color"}
                                label="Cor"
                                checked={toggleItemsNode.vehicle.color}
                                onChange={(checked) => handleCheckBox(checked, "color", "vehicle")}
                            />
                        </div>
                        <div className={"mb-1"}>
                            <InputSwitch
                                id={"year"}
                                label="Ano"
                                checked={toggleItemsNode.vehicle.year}
                                onChange={(checked) => handleCheckBox(checked, "year", "vehicle")}
                            />
                        </div>
                        <div>
                            <InputSwitch
                                id={"last_passage"}
                                label="Imagem da última passagem"
                                checked={toggleItemsNode.vehicle.last_passage}
                                onChange={(checked) => handleCheckBox(checked, "last_passage", "vehicle")}
                            />
                        </div>
                    </div>
                    <div className={"mb-2"}>
                        <p className={"text-[16px] font-bold mb-1"}>Abordagens</p>
                        <div className={"mb-1"}>
                            <InputSwitch
                                id={"individuals"}
                                label="Quantidade de indivíduos"
                                checked={toggleItemsNode.encounter.individuals}
                                onChange={(checked) => handleCheckBox(checked, "individuals", "encounter")}
                            />
                        </div>
                        <div>
                            <InputSwitch
                                id={"vehicles"}
                                label="Quantidade de veículos"
                                checked={toggleItemsNode.encounter.vehicles}
                                onChange={(checked) => handleCheckBox(checked, "vehicles", "encounter")}
                            />
                        </div>
                    </div>
                    <div className={"mb-2"}>
                        <p className={"text-[16px] font-bold mb-1"}>Ocorrência</p>
                        <div className={"mb-1"}>
                            <InputSwitch
                                id={"address"}
                                label="Endereço"
                                checked={toggleItemsNode.occurrence.address}
                                onChange={(checked) => handleCheckBox(checked, "address", "occurrence")}
                            />
                        </div>
                        <div className={"mb-1"}>
                            <InputSwitch
                                id={"reason"}
                                label="Natureza"
                                checked={toggleItemsNode.occurrence.reason}
                                onChange={(checked) => handleCheckBox(checked, "reason", "occurrence")}
                            />
                        </div>
                        <div className={"mb-1"}>
                            <InputSwitch
                                id={"status"}
                                label="Status"
                                checked={toggleItemsNode.occurrence.status}
                                onChange={(checked) => handleCheckBox(checked, "status", "occurrence")}
                            />
                        </div>
                        <div>
                            <InputSwitch
                                id={"description"}
                                label="Descrição"
                                checked={toggleItemsNode.occurrence.description}
                                onChange={(checked) => handleCheckBox(checked, "description", "occurrence")}
                            />
                        </div>
                    </div>
                    <div className={"mb-2"}>
                        <p className={"text-[16px] font-bold mb-1"}>SOS</p>
                        <div className={"mb-1"}>
                            <InputSwitch
                                id={"status"}
                                label="Situação"
                                checked={toggleItemsNode.sos.status}
                                onChange={(checked) => handleCheckBox(checked, "status", "sos")}
                            />
                        </div>
                        <div>
                            <InputSwitch
                                id={"address"}
                                label="Endereço"
                                checked={toggleItemsNode.sos.address}
                                onChange={(checked) => handleCheckBox(checked, "address", "sos")}
                            />
                        </div>
                    </div>
                    <div className={"mb-2"}>
                        <p className={"text-[16px] font-bold mb-1"}>BO</p>
                        <div className={"mb-1"}>
                            <InputSwitch
                                id={"address"}
                                label="Endereço"
                                checked={toggleItemsNode.bo.address}
                                onChange={(checked) => handleCheckBox(checked, "address", "bo")}
                            />
                        </div>
                        <div>
                            <InputSwitch
                                id={"flagrant"}
                                label="Flagrante"
                                checked={toggleItemsNode.bo.flagrant}
                                onChange={(checked) => handleCheckBox(checked, "flagrant", "bo")}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Config;